import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLifeVest: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="life-vest, vest"><path d="M7.75 2.76C7.75 8.58667 16.25 8.58667 16.25 2.76M7.75 2.76C7.75 5.77482 7.75 9.75003 3.75 9.75003V20.25H20.25V9.75003C16.25 9.62222 16.25 5.77482 16.25 2.76M7.75 2.76V2.75M16.25 2.76V2.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12 7.25V11.75M12 11.75V15.75M12 11.75H9.75M12 11.75H14.25M12 15.75V20.25M12 15.75H3.75M12 15.75H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconLifeVest;
